import React, { useEffect, useState } from "react";
import { Button, Container, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import CommonReactTable from "../../CommonUtils/CommonReactTable";
import { CommonAxiosGet } from "../../CommonUtils/CommonAxios";
import { config } from "../../CommonUtils/CommonURLS";
import { FaEye } from "react-icons/fa";
import OverseasFormPreview from "../StuServices/OverseasFormPreview";
import CommonCardHeader from "../../CommonUtils/CommonCardHeader";

export default function OciAdmissionDetailsReport() {
    const navigate = useNavigate();
    const login = sessionStorage.getItem("user_id");
    const isCteAdmin = login?.toLowerCase() === "cteadmin";
    console.log("login", login);
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showPreviewModal, setShowPreviewModal] = useState(false);
    const [selectedStudentData, setSelectedStudentData] = useState(null);

    const handleOpenPreview = (studentData) => {
        setSelectedStudentData(studentData);
        setShowPreviewModal(true);
    };

    const handleClosePreview = () => {
        setShowPreviewModal(false);
        setSelectedStudentData(null);
    };

    const loadOciAdmissionRows = async () => {
        setLoading(true);
        try {
            const urlWithLogin = `${config.url.STU_URL}${isCteAdmin ? "getOciAdmissionDetailsdept" : "getOciAdmissionDetailscollege"}`;

            let res = await CommonAxiosGet(urlWithLogin);


            const payload = res?.data || {};
            const apiRows = payload?.data || payload?.students || payload?.college_students || [];
            setRows(Array.isArray(apiRows) ? apiRows : []);
        } catch (error) {
            console.error("Error loading OCI admission report:", error);
            setRows([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadOciAdmissionRows();
    }, []);

    const columns = [
        {
            id: "slNo",
            header: "S.No",
            cell: ({ row }) => row.index + 1,
        },
        {
            id: "application_no",
            header: "Application No",
            accessorKey: "application_no",
        },
        {
            id: "student_name",
            header: "Student Name",
            accessorKey: "student_name",
            cell: ({ row }) => row.original.student_name || "-",
        },
        {
            id: "fathers_name",
            header: "Father Name",
            accessorKey: "fathers_name",
            cell: ({ row }) => row.original.fathers_name || "-",
        },
        {
            id: "gender",
            header: "Gender",
            accessorKey: "gender",
            cell: ({ row }) => row.original.gender || "-",
        },
        ...(isCteAdmin
            ? [
                {
                    id: "college_name",
                    header: "College Name",
                    cell: ({ row }) =>
                        row.original.college_name || "-",
                },
            ]
            : []),
        {
            id: "course",
            header: "Course",
            accessorKey: "course",
            cell: ({ row }) => row.original.course || "-",
        },
        {
            id: "branch",
            header: "Course Name",
            accessorKey: "branch",
            cell: ({ row }) => row.original.branch || "-",
        },
        // {
        //     id: "status",
        //     header: "Status",
        //     accessorKey: "status",
        //     cell: ({ row }) => row.original.status || "-",
        // },
        {
            id: "preview",
            header: "Preview",
            cell: ({ row }) => (
                <div className="text-center">
                    <Button
                        size="sm"
                        variant="outline-primary"
                        onClick={() => handleOpenPreview(row.original)}
                    >
                        <FaEye />
                    </Button>
                </div>
            ),
        },
    ]

    return (
        <Container fluid className="py-4">
            <Modal show={showPreviewModal} onHide={handleClosePreview} size="xl" centered backdrop="static" keyboard={false} >
                {/* <Modal.Header closeButton>
                    <Modal.Title>OCI Admission Details </Modal.Title>
                </Modal.Header> */}
                <Modal.Body>
                    {selectedStudentData && (
                        <OverseasFormPreview studentData={selectedStudentData} onBack={handleClosePreview} />
                    )}
                </Modal.Body>
            </Modal>
            <section className="workflow-section-surface">
                <CommonCardHeader
                    title="Overseas Admission Report"
                    actionLabel={isCteAdmin ? undefined : "Click here for New Student"}
                    onAction={isCteAdmin ? undefined : () => navigate("/OCIAdmissionsForm", { state: { mode: "new" } })}
                />
                <div className="workflow-section-body">
                    {loading ? (
                        <div className="text-center fw-semibold">Loading...</div>
                    ) : rows.length > 0 ? (
                        <CommonReactTable
                            data={rows}
                            columns={columns}
                            filename="Overseas AdmissionDetailsReport"
                            headerName="Overseas Admission Details Report"
                            showFooter={false}
                            showPagination={false}
                            showExcel={true}
                            showPrint={true}
                            excelFileName="OCI_Admission_Details_Report"
                        />
                    ) : (
                        <div className="text-center text-danger fw-bold fs-6">**** No Data Found ****</div>
                    )}
                </div>
            </section>
        </Container>
    );
}
